













import { Component, Vue } from 'vue-property-decorator';
import { DxNumberBox } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { GenerateAdvancedInvoiceCommand, InvoicesClient } from '@/data/web-api-client';
import { CompanyConfig } from '@/installationConfig';

@Component({
  components: {
    DxNumberBox,
    Popup,
  },
})
export default class InvoiceGenerateAdvanceDialog extends Vue {
  public quotationIds?: string[];
  public show: boolean = false;
  saving: boolean = false;
  loading: boolean = false;
  percentage: number = 35;

  mounted() {
    if (CompanyConfig.companyName == 'OneSkin') {
      this.percentage = 15;
    }
  }

  public hideDialog() {
    this.show = false;
  }

  public async save() {
    try {
      this.saving = true;
      const result = await new InvoicesClient(undefined, this.$axios).generateAdvancedInvoice(
        new GenerateAdvancedInvoiceCommand({
          sourceList: this.quotationIds,
          percentage: this.percentage,
        })
      );
      notificationService.saved();
      this.$router.push({ path: `/invoices/${result}` });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
